function checkWizzyConfigAndUpdate() {
  window.wizzyConfig &&
    (window.matchMedia("(max-width: 768px)").matches
      ? (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: "#search_mini_form .wizzy-search-form .input-text", // mobile searchbar
          type: "text",
        })
      : (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: "header input.header-search__input", // desktop searchbar
          type: "search",
        }),
    clearInterval(interval));
}
var interval = setInterval(checkWizzyConfigAndUpdate, 100);

const searchIcon = document.querySelector(
  "header .header__secondary-nav .header__nav-icon.icon-search"
);

const searchInput =
  window.innerWidth < 768
    ? document.querySelector("#search_mini_form .wizzy-search-form .input-text")
    : document.querySelector(
        "#predictive-search-form .header-search__form-control .header-search__input"
      );

searchIcon?.addEventListener("click", () => {
  searchInput?.click();
});

// // Select the target div
// let firstDiv = document.querySelector(".header-search");
// let secondDiv = document.querySelector(".wizzy-autocomplete-wrapper");

// // Function to toggle the second div based on first div's display property
// function toggleSecondDiv() {
//   if (window.getComputedStyle(firstDiv).display === "block" && secondDiv) {
//     secondDiv.style.display = "block";
//   } else {
//     secondDiv.style.display = "none";
//   }
// }

// // Create an observer instance
// let observer = new MutationObserver(() => {
//   toggleSecondDiv(); // Call function when mutation is detected
// });

// // Observer configuration (detect changes in attributes)
// observer.observe(firstDiv, { attributes: true, attributeFilter: ["style"] });

document.addEventListener("click", function (event) {
  const targetDiv = document.querySelector(".wizzy-product-list-usf"); // Find the div
  if (event.target.classList.contains("collection-toolbar__button-grid")) {
    if (targetDiv) {
      targetDiv.classList.add("product-list");
      targetDiv.classList.add("usf-grid");

      targetDiv.classList.remove("list-view-items");
      targetDiv.classList.remove("usf-list");
    }
  }

  if (event.target.classList.contains("collection-toolbar__button-list")) {
    if (targetDiv) {
      targetDiv.classList.remove("product-list");
      targetDiv.classList.remove("usf-grid");

      targetDiv.classList.add("list-view-items");
      targetDiv.classList.add("usf-list");
    }
  }
});

const addDiscountSort = (filter, isFilter) => {
  let isJson = false,
    isSortJson = false;
  typeof filter == "string" && ((isJson = true), (filter = JSON.parse(filter))),
    typeof filter.sort == "string" &&
      ((isSortJson = true), (filter.sort = JSON.parse(filter.sort)));
  let newSort = [];
  if (filter.sort[0].field === "relevance") {
    newSort.push({
      field: "discountPercentage",
      order: "desc",
    }),
      filter.sort.forEach((x) => {
        x.field != "discountPercentage" && newSort.push(x);
      });
  } else {
    newSort = filter.sort;
  }

  (filter.sort = newSort),
    isSortJson && (filter.sort = JSON.stringify(filter.sort)),
    isJson && (filter = JSON.stringify(filter));
};

let wizzyEvents = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      if (window.matchMedia("(max-width: 768px)").matches) {
        data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: "#search_mini_form .wizzy-search-form .input-text", // mobile searchbar
          type: "text",
        };
      } else {
        data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: "header input.header-search__input", // desktop searchbar
          type: "search",
        };
      }
      data.common.lazyDOMConfig.contentDOMIdentifiers = ["body main"];
      data.search.configs.pagination.appendInExistingList = true;
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = true;

      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      data.search.configs.pagination.appendInExistingList = true;
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      addDiscountSort(data);
      if (window.innerWidth < 768) {
        var searchform = document.querySelector(
          ".wizzy-search-form-wrapper.mf-initial "
        );
        if (searchform && searchform.classList.contains("mobileTapped")) {
          searchform.classList.remove("mobileTapped");
        }
      } else {
        var searchBarCloseBtn = document.querySelector(
          "#predictive-search-form .header-search__form-control dialog-close-button"
        );
        if (searchBarCloseBtn) {
          searchBarCloseBtn.click();
        }
      }

      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      products.forEach((product) => {
        if (product.mainVideo) {
          product.isMainVideo = true;
        }
        if (product.attributes) {
          product.attributes.forEach((atr) => {
            if (atr.id === "product_badge_judgeme") {
              var htmlString = atr.values[0].value[0];
              var tempElement = document.createElement("div");
              tempElement.innerHTML = htmlString;
              var tempAverageRating = tempElement
                .querySelector(".jdgm-prev-badge")
                .getAttribute("data-average-rating");
              var tempReview = tempElement
                .querySelector(".jdgm-prev-badge")
                .getAttribute("data-number-of-reviews");
              var avgRating =
                tempAverageRating.split(".")[0] +
                "." +
                tempAverageRating.split(".")[1][0];

              const reviewTextElement = tempElement.querySelector(
                ".jdgm-prev-badge__text"
              );

              if (reviewTextElement) {
                // Update the content dynamically
                reviewTextElement.innerHTML = `(${avgRating} | ${tempReview})`;
              }

              product.reviewHtml = tempElement.innerHTML;
            } else if (atr.id === "product_vendor") {
              product.brand = atr.values[0].value[0];
            }
          });
        }
      });
      return products;
    }
  );
};

window.onWizzyLoaded.push(wizzyEvents);
